import { Component, inject } from '@angular/core';
import {
  RdsDialogContentDirective,
  RdsDialogHeaderDirective,
  RdsDialogTitleDirective,
  RdsDialogCloseDirective,
  RdsIconComponent,
  RdsIconButtonComponent,
  RDS_DIALOG_DATA,
} from '@rds/angular-components';

export interface LegalDialogData {
  title: string;
  htmlContent: string;
}

@Component({
  selector: 'app-legal-dialog',
  standalone: true,
  imports: [
    RdsDialogContentDirective,
    RdsDialogHeaderDirective,
    RdsDialogTitleDirective,
    RdsDialogCloseDirective,
    RdsIconComponent,
    RdsIconButtonComponent,
  ],
  template: `
    <div rds-dialog-header>
      <h2 rds-dialog-title>{{ data.title }}</h2>
      <button rds-icon-button rds-dialog-close aria-label="Close">
        <rds-icon icon="close" namespace="outlined" />
      </button>
    </div>
    <!-- Safe: htmlContent is always a compile-time constant from legal-content.ts.
         Do NOT pass user-supplied or API-fetched HTML here without sanitization. -->
    <div rds-dialog-content>
      <div class="ui-body-m" [innerHTML]="data.htmlContent"></div>
    </div>
  `,
  styles: [
    `
      :host ::ng-deep .legal-section {
        margin-bottom: 16px;
      }
      :host ::ng-deep .legal-section:last-child {
        margin-bottom: 0;
      }
      :host ::ng-deep h3 {
        margin-bottom: 8px;
      }
      :host ::ng-deep a {
        color: var(--rds-color-link);
      }
    `,
  ],
})
export class LegalDialogComponent {
  readonly data: LegalDialogData = inject(RDS_DIALOG_DATA) as LegalDialogData;
}
